import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { contactInfoApi } from '../../services/webApi';
import api from '../../services/api';

const Iletisim = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    subject: '',
    message: ''
  });
  const [contactInfo, setContactInfo] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    // Initialize AOS
    const initAOS = () => {
      if (window.AOS) {
        window.AOS.init();
      }
    };

    // Initialize Lucide Icons
    const initLucide = () => {
      if (window.lucide && window.lucide.createIcons) {
        window.lucide.createIcons();
      }
    };

    // Fetch contact info from API
    const fetchContactInfo = async () => {
      try {
        const response = await contactInfoApi.getAll();
        if (isMounted && response.data.success) {
          setContactInfo(response.data.data);
        } else if (isMounted) {
          setError('Veriler yüklenemedi');
        }
      } catch (err) {
        console.error('Contact info fetch error:', err);
        if (isMounted) {
          setError('Veriler yüklenirken hata oluştu');
          // Fallback to static data
          setContactInfo([
            {
              id: 1,
              type: 'address',
              value: 'Halkapınar Mah. 1203/11 Sk. No:5-7/72 Konak /İZMİR',
              icon: 'map-pin',
              is_active: true,
              sort_order: 1
            },
            {
              id: 2,
              type: 'phone',
              value: '0850 455 01 64',
              icon: 'phone',
              is_active: true,
              sort_order: 2
            },
            {
              id: 3,
              type: 'email',
              value: 'info@kalemweb.com.tr',
              icon: 'mail',
              is_active: true,
              sort_order: 3
            }
          ]);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    // Hemen başlat
    initAOS();
    fetchContactInfo();

    return () => {
      isMounted = false;
    };
  }, []);

  // Initialize icons when contact info is loaded and periodically refresh
  useEffect(() => {
    const initIcons = () => {
      if (window.lucide && window.lucide.createIcons) {
        try {
          window.lucide.createIcons();
        } catch (error) {
          console.error('Error creating icons:', error);
        }
      }
    };

    if (!loading) {
      // Initial setup
      setTimeout(initIcons, 100);
      
      // Also re-init periodically to catch any missed icons
      const interval = setInterval(initIcons, 500);
      
      return () => clearInterval(interval);
    }
  }, [loading, contactInfo.length]);

  const handleChange = (e) => {
    let value = e.target.value;
    
    // Telefon numarası için format kontrolü
    if (e.target.name === 'phone') {
      // Sadece rakam ve + karakterine izin ver
      value = value.replace(/[^0-9+]/g, '');
      
      // Türk telefon formatına göre düzenle
      if (value.length > 0 && !value.startsWith('+')) {
        if (value.length <= 11) {
          // 0XXXXXXXXXX formatına çevir
          if (value.length === 10 && !value.startsWith('0')) {
            value = '0' + value;
          }
        } else {
          // Çok uzun ise kes
          value = value.substring(0, 11);
        }
      }
    }
    
    setFormData({
      ...formData,
      [e.target.name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Frontend validasyonu
    if (!formData.name.trim()) {
      toast.error('Ad Soyad alanı zorunludur.');
      return;
    }
    
    if (!formData.email.trim()) {
      toast.error('E-posta alanı zorunludur.');
      return;
    }
    
    if (!formData.phone.trim()) {
      toast.error('Telefon numarası zorunludur.');
      return;
    }
    
    if (!formData.subject) {
      toast.error('Konu seçimi zorunludur.');
      return;
    }
    
    if (!formData.message.trim()) {
      toast.error('Mesaj alanı zorunludur.');
      return;
    }
    
    // Telefon format kontrolü
    const phoneRegex = /^0[5][0-9]{9}$/;
    if (!phoneRegex.test(formData.phone)) {
      toast.error('Geçerli bir telefon numarası giriniz. (Örn: 05551234567)');
      return;
    }
    
    // E-posta format kontrolü
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      toast.error('Geçerli bir e-posta adresi giriniz.');
      return;
    }
    
    // Loading toast
    const loadingToast = toast.loading('Mesajınız gönderiliyor...');
    
    try {
      const response = await api.post('/contact', formData);
      const result = response.data;
      
      // Dismiss loading toast
      toast.dismiss(loadingToast);
      
      if (result.success) {
        toast.success('Mesajınız başarıyla gönderildi! En kısa sürede size dönüş yapacağız.', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        
        // Form'u temizle
        setFormData({
          name: '',
          email: '',
          phone: '',
          company: '',
          subject: '',
          message: ''
        });
      } else {
        toast.error(result.message || 'Bir hata oluştu. Lütfen tekrar deneyin.', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
    } catch (error) {
      console.error('Form submission error:', error);
      
      // Dismiss loading toast
      toast.dismiss(loadingToast);
      
      toast.error('Bir hata oluştu. Lütfen tekrar deneyin.', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  // Helper function to get title for contact info type
  const getContactTitle = (type) => {
    switch (type) {
      case 'address': return 'Adres';
      case 'phone': return 'Telefon';
      case 'email': return 'E-posta';
      default: return 'İletişim';
    }
  };

  // Helper function to get icon for contact info type
  const getContactIcon = (type, fallbackIcon) => {
    if (fallbackIcon) return fallbackIcon;
    
    switch (type) {
      case 'address': return 'map-pin';
      case 'phone': return 'phone';
      case 'email': return 'mail';
      default: return 'phone';
    }
  };

  // Map address is sourced from panel contact info (type: address)
  const defaultAddress = 'İsmet Kaptan Mah. Sezer Doğan Sk. A No: 12 İç Kapı No: 5 Konak / İzmir';
  const addressInfo = contactInfo.find((item) => item.type === 'address' && item.value);
  const mapAddress = (addressInfo?.value || defaultAddress).trim();
  const encodedMapAddress = encodeURIComponent(mapAddress);
  const mapEmbedUrl = `https://www.google.com/maps?q=${encodedMapAddress}&output=embed`;
  const mapExternalUrl = `https://www.google.com/maps/search/?api=1&query=${encodedMapAddress}`;

  return (
    <>
      {/* Hero Section */}
      <section className="relative overflow-hidden pt-[72px] backdrop-blur-3xl">
        <div className="overlay"></div>
        <div className="stars" aria-hidden="true"></div>
        <div className="starts2" aria-hidden="true"></div>
        <div className="stars3" aria-hidden="true"></div>

        <div className="px-6 pt-20 overflow-hidden" data-aos="fade-up" data-aos-easing="ease" data-aos-duration="800">
          <div className="container">
            <div className="py-14 text-center relative">
              <div className="flex justify-center">
                <div className="max-w-2xl">
                  <h2 className="md:text-6xl/tight text-5xl text-default-100 font-semibold mb-6">
                    <span className="bg-gradient-to-l from-rose-500 to-primary text-transparent bg-clip-text">İletişim</span>
                    <br />Bizimle İletişime Geçin
                  </h2>
                  <p className="text-sm font-medium text-default-400 mt-5">
                    Sorularınız, önerileriniz veya destek talepleriniz için bizimle iletişime geçebilirsiniz. Size en kısa sürede dönüş yapacağız.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Info */}
      <section className="py-14">
        <div className="container">
          {loading ? (
            <div className="text-center py-8">
              <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
              <p className="text-default-400 mt-4">İletişim bilgileri yükleniyor...</p>
            </div>
          ) : error ? (
            <div className="text-center py-8">
              <p className="text-red-500">{error}</p>
            </div>
          ) : (
            <div className="grid md:grid-cols-3 gap-6 mb-14">
              {contactInfo.map((info, index) => (
                <div 
                  key={`${info.id}-${info.icon}-${index}`}
                  className="text-center p-6 rounded-xl bg-default-950/40 transition-all duration-500 hover:-translate-y-2 hover:bg-primary/40"
                  data-aos="fade-up" 
                  data-aos-easing="ease" 
                  data-aos-duration="1000"
                  data-aos-delay={index * 100}
                >
                  <div className="h-14 w-14 flex items-center justify-center rounded-lg bg-primary/20 text-primary mx-auto mb-4">
                    <i data-lucide={getContactIcon(info.type, info.icon)} className="h-9 w-9"></i>
                  </div>
                  <h3 className="text-xl font-medium text-default-200 mb-4">{getContactTitle(info.type)}</h3>
                  <div className="space-y-1">
                    <p className="text-sm text-default-300">{info.value}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Contact Form */}
      <section className="py-14">
        <div className="container">
          <div className="grid md:grid-cols-2 gap-6 items-start">
            {/* Contact Form */}
            <div className="bg-default-950/40 backdrop-blur-3xl rounded-xl p-8" data-aos="fade-right" data-aos-easing="ease" data-aos-duration="1000">
              <h2 className="text-2xl text-white font-medium mb-6">Mesaj Gönderin</h2>
              <form onSubmit={handleSubmit} className="space-y-6">
                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-default-200 mb-2">Ad Soyad *</label>
                    <input
                      type="text"
                      name="name"
                      required
                      value={formData.name}
                      onChange={handleChange}
                      className="w-full px-4 py-3 bg-default-900/50 border border-white/10 rounded-lg text-white placeholder-default-400 focus:outline-none focus:border-primary transition-colors"
                      placeholder="Adınız ve soyadınız"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-default-200 mb-2">E-posta *</label>
                    <input
                      type="email"
                      name="email"
                      required
                      value={formData.email}
                      onChange={handleChange}
                      className="w-full px-4 py-3 bg-default-900/50 border border-white/10 rounded-lg text-white placeholder-default-400 focus:outline-none focus:border-primary transition-colors"
                      placeholder="ornek@email.com"
                    />
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-default-200 mb-2">Telefon *</label>
                    <input
                      type="tel"
                      name="phone"
                      required
                      value={formData.phone}
                      onChange={handleChange}
                      className="w-full px-4 py-3 bg-default-900/50 border border-white/10 rounded-lg text-white placeholder-default-400 focus:outline-none focus:border-primary transition-colors"
                      placeholder="0850 455 01 64"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-default-200 mb-2">Şirket</label>
                    <input
                      type="text"
                      name="company"
                      value={formData.company}
                      onChange={handleChange}
                      className="w-full px-4 py-3 bg-default-900/50 border border-white/10 rounded-lg text-white placeholder-default-400 focus:outline-none focus:border-primary transition-colors"
                      placeholder="Şirket adınız"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-default-200 mb-2">Konu *</label>
                  <select
                    name="subject"
                    required
                    value={formData.subject}
                    onChange={handleChange}
                    className="w-full px-4 py-3 bg-default-900/50 border border-white/10 rounded-lg text-white focus:outline-none focus:border-primary transition-colors"
                  >
                    <option value="">Konu seçin</option>
                    <option value="demo">Demo Talebi</option>
                    <option value="support">Teknik Destek</option>
                    <option value="sales">Satış Bilgisi</option>
                    <option value="integration">Entegrasyon</option>
                    <option value="other">Diğer</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-default-200 mb-2">Mesaj *</label>
                  <textarea
                    name="message"
                    required
                    rows={5}
                    value={formData.message}
                    onChange={handleChange}
                    className="w-full px-4 py-3 bg-default-900/50 border border-white/10 rounded-lg text-white placeholder-default-400 focus:outline-none focus:border-primary transition-colors resize-none"
                    placeholder="Mesajınızı buraya yazın..."
                  />
                </div>

                <button
                  type="submit"
                  className="w-full bg-primary text-white py-3 px-6 rounded-lg hover:bg-primary-hover transition-colors font-medium"
                >
                  Mesaj Gönder
                </button>
              </form>
            </div>

            {/* Map and Additional Info */}
            <div className="space-y-6" data-aos="fade-left" data-aos-easing="ease" data-aos-duration="1000">
              {/* Map */}
              <div className="bg-default-950/40 backdrop-blur-3xl rounded-xl p-8">
                <h3 className="text-xl text-white font-medium mb-4">Konumumuz</h3>
                <div className="w-full h-64 rounded-lg overflow-hidden border border-white/10">
                  <iframe
                    src={mapEmbedUrl}
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="ISP Radius - Konum"
                  ></iframe>
                </div>
                <div className="mt-4 text-center">
                  <p className="text-sm text-default-300 mb-2">{mapAddress}</p>
                  <a 
                    href={mapExternalUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center text-primary hover:text-primary-hover transition-colors"
                  >
                    <i data-lucide="external-link" className="h-4 w-4 mr-1"></i>
                    <span className="text-sm">Google Maps'te Aç</span>
                  </a>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Iletisim;
